import * as locationTypes from '../../../../common/redux/actions/types/LocationTypes';

export default function filterUnlocodesIfExistsInPostalOperators(
  unlocodes,
  postalOperators,
  reportDefinition,
) {
  const result = [];

  if (!reportDefinition || !postalOperators || postalOperators.length === 0) {
    return [...unlocodes];
  }

  const addIfExists = (unlocode) => {
    if (unlocodes.includes(unlocode)) {
      result.push(unlocode);
    }
  };

  // eslint-disable-next-line no-plusplus
  for (let index = 0; index < postalOperators.length; index++) {
    const postalOperator = postalOperators[index];

    addIfExists(postalOperator.value);
    // eslint-disable-next-line
    for (let i = 0; i < postalOperator.children.length; i++) {
      const unlocode = postalOperator.children[i];
      if (reportDefinition.locationType === locationTypes.OPERATOR) {
        if (unlocodes.includes(unlocode.value)) {
          result.push(...postalOperator.children.map(child => child.value));
          break;
        }
      } else {
        addIfExists(unlocode.value);
      }
    }
  }

  return result;
}
